module.exports = __webpack_public_path__ + "img/certificate2.81da4856.jpg";